var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoggedUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M16.64 22H7.36C6.34918 21.9632 5.40757 21.477 4.79235 20.6741C4.17713 19.8713 3.95257 18.8356 4.18 17.85L4.42 16.71C4.69604 15.1668 6.02262 14.0327 7.59 14H16.41C17.9774 14.0327 19.304 15.1668 19.58 16.71L19.82 17.85C20.0474 18.8356 19.8229 19.8713 19.2077 20.6741C18.5924 21.477 17.6508 21.9632 16.64 22Z",
    fill: "#626262"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M12.5 12H11.5C9.29088 12 7.50001 10.2092 7.50001 8.00001V5.36001C7.49735 4.46807 7.85049 3.61189 8.48119 2.98119C9.11189 2.35049 9.96807 1.99735 10.86 2.00001H13.14C14.032 1.99735 14.8881 2.35049 15.5188 2.98119C16.1495 3.61189 16.5027 4.46807 16.5 5.36001V8.00001C16.5 9.06088 16.0786 10.0783 15.3284 10.8284C14.5783 11.5786 13.5609 12 12.5 12Z",
    fill: "#626262"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoggedUser);
export default __webpack_public_path__ + "static/media/LoggedUser.16f5a176.svg";
export { ForwardRef as ReactComponent };